<template>
  <v-container>
    <v-layout row>
      <v-flex grow class="flights">
        <div v-if="loading !== true && loading2 !== true" key="3">
          <FlightSelect ref="FlightSelect" :searchType="searchType" />
        </div>
        <div v-if="loading === true" key="1" class="loading search_pad">
          <pulse-loader :loading="loading"></pulse-loader>
        </div>
        <div v-if="loading2 === true && loading === false" key="2" class="loading search_pad">
          <pulse-loader :loading="loading2"></pulse-loader>
        </div>
      </v-flex>
      <v-flex v-if="mobileDevice === false && col_mode === true && form_fields.dest_loc > 0" sm5 lg4>
        <FareOptionsColumn
          :fareType="getSelFareType"
          :departure="getSelDepLoc"
          :destination="getSelDestLoc"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import store from "../../../store";
import Shared from "@/mixins/Shared";
import FlightSelect from "@/components/forms/sections/FlightSelect.vue";
import FareOptionsColumn from "@/components/forms/sections/FareOptionsColumn.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { createHelpers } from "vuex-map-fields";

const { mapFields } = createHelpers({
  getterType: "getField"
});

export default {
  name: "FlightSearchLoader",
  props: ["searchType"],
  mixins: [Shared],
  computed: {
    ...mapFields([
      "steps",
      "loading",
      "loading2",
      "departingFlights",
      "returningFlights"
    ])
  },
  data: () => ({
    store: store,
    error: false
  }),
  components: {
    PulseLoader,
    FlightSelect,
    FareOptionsColumn
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/flight_search.scss";
</style>
